export default {
  title: 'principal',
  colors: {
    redNut: '#E33838',
    coolBlue: '#D1FAFA',
    cream: '#FEF2EB',
    darkGray: '#383636',
  },
  header: {
    color: '#fff',
    colorMobile: '#fff',
    textColor: '#383636',
    buttonBuyColor: '#E33838',
  },
};
